import Vue from 'vue'
import Router from 'vue-router'
import {mallSubmit, getCookie, commonApi} from "../api/permission";

Vue.use(Router);
//按需加载,当渲染其他页面时才加载其组件,并缓存,减少首屏加载时间
const Index = resolve => require(['@/views/Index.vue'], resolve);
const Detail = resolve => require(['@/views/Detail.vue'], resolve);
const Pay = resolve => require(['@/views/Pay.vue'], resolve);
const Success = resolve => require(['@/views/Success.vue'], resolve);
const Search = resolve => require(['@/views/Search.vue'], resolve);
const ShippingPolicy = resolve => require(['@/views/Policy/ShippingPolicy.vue'], resolve);
const FAQ = resolve => require(['@/views/Policy/FAQ.vue'], resolve);
const ReturnPolicy = resolve => require(['@/views/Policy/ReturnPolicy.vue'], resolve);
const PrivacyPolicy = resolve => require(['@/views/Policy/PrivacyPolicy.vue'], resolve);
const Error = resolve => require(['@/views/Error.vue'], resolve);
const Promotion = resolve => require(['@/views/Promotion.vue'], resolve);
const myRouter = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: '首页',
      component: Index,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    }, {
      path: '/detail',
      name: '详情页',
      component: Detail,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    }, {
      path: '/pay',
      name: '支付页',
      component: Pay,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    }, {
      path: '/success',
      name: '成功页',
      component: Success,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    }, {
      path: '/search',
      name: '查询页',
      component: Search,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    }, {
      path: '/shipping',
      name: '发货政策',
      component: ShippingPolicy,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    }, {
      path: '/faq',
      name: '常见问题',
      component: FAQ,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    }, {
      path: '/return',
      name: '退货政策',
      component: ReturnPolicy,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    }, {
      path: '/privacy',
      name: '隐私政策',
      component: PrivacyPolicy,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    }, {
      path: '/Promotion/:id',
      name: '活动页',
      component: Promotion,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    }, {
      path: '/collections-big-sale',
      name: '活动页',
      component: Promotion,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    },
    {
      path: '/error',
      name: 'error',
      component: Error,
      meta: {
        title: sessionStorage.seo_title,
        content:{
          keywords:sessionStorage.seo_keywords,
          description:sessionStorage.seo_description,
        }
      }
    },
  ]
});

myRouter.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next( {
      path: '/error',
      query: to.query
    })
    // 储存错误的路由地址，方便以后使用
    sessionStorage.errorUri = to.fullPath;
    return;
  }
  /* 路由发生变化修改页面meta */
  if(to.meta.content || sessionStorage.seo_keywords){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords || sessionStorage.seo_keywords);
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description || sessionStorage.seo_description)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title || sessionStorage.seo_title) {
    document.title = to.meta.title || sessionStorage.seo_title;
  }
  /* 路由切换时，如果没有就添加，有就跳过执行，添加固定参数 */
  let query = to.query;
  let queryCtrl = false;
  if (from.query.atm && !to.query.atm) {
    query.atm = from.query.atm;
    queryCtrl = true;
  }
  if (from.query.cl && !to.query.cl) {
    query.cl = from.query.cl;
    queryCtrl = true;
  }
  if (from.query.u && !to.query.u) {
    query.u = from.query.u;
    queryCtrl = true;
  }
  if (from.query.utm_source && !to.query.utm_source) {
    query.utm_source = from.query.utm_source;
    queryCtrl = true;
  }
  if (from.query.utm_medium && !to.query.utm_medium) {
    query.utm_medium = from.query.utm_medium;
    queryCtrl = true;
  }
  if (from.query.aid && !to.query.aid) {
    query.aid = from.query.aid;
    queryCtrl = true;
  }
  if (from.query.source && !to.query.source) {
    query.source = from.query.source;
    queryCtrl = true;
  }
  if (from.query.home && !to.query.home) {
    query.home = from.query.home;
    queryCtrl = true;
  }
  if(queryCtrl) {
    next({
      path: to.path,
      query: query
    });
  } else {
    next();
    let event_label  = '';
    if (to.path === '/detail') {
      event_label = 'home';
    } else if (to.path === '/pay') {
      event_label = 'pay';
    } else if (to.path === '/search') {
      event_label = 'query';
    } else if (to.path === '/success') {
      event_label = 'success';
    }
    gtag('event', 'PageView', {
      event_category: window.location.href,
      event_label,
      value: startTime
    });
    mallSubmit({
      event_name: 'PageView',
      event_label,
    });
    if (typeof snaptr === 'function') {
      try {
        snaptr('track', 'PAGE_VIEW');
      } catch (error) {
        console.log(error);
      }
    }
    if (window.isEnableTtqTrack()) {
      const eventId = localStorage.getItem('pageViewEventId') || window.guid();
      // 上报后删除事件id
      localStorage.removeItem('pageViewEventId');
      const ttq = window.ttq || {};
      const pixel = Object.keys(ttq._i || {})[0];
      commonApi("/api/tt/track", {
        pixel,
        request: {
          event_source: "web",
          event_source_id: pixel,
          data: [
            {
              event: "PageView",
              event_time: Math.floor(Date.now() / 1000),
              event_id: eventId,
              user: {
                ttclid: getCookie("ttclid") || "",
                ttp: getCookie("_ttp") || "",
                ip: "",
                user_agent: navigator.userAgent,
              },
              page: {
                url: location.href,
              },
            },
          ],
        },
      }).catch(err => {
        console.log('err', err);
      });
    }
  }
});

myRouter.onError((err) => {
  console.log('222');
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = err.message.match(pattern);
  if (isChunkLoadFailed) {
    let chunkBool = sessionStorage.getItem('chunkError');
    let nowTimes = Date.now();
    if (chunkBool === null || chunkBool && nowTimes - parseInt(chunkBool) > 60000) { //路由跳转报错,href手动跳转
      sessionStorage.setItem('chunkError', 'reload');
      const targetPath = myRouter.history.pending.fullPath;
      window.location.href = window.location.origin + targetPath;
    } else if (chunkBool === 'reload') { //手动跳转后依然报错,强制刷新
      sessionStorage.setItem('chunkError', Date.now());
      window.location.reload(true);
    }
  }
});
export default myRouter



// WEBPACK FOOTER //
// ./src/router/index.js